import qs from 'qs'
import { axios } from '@/utils/request'

const api = {
  queryTagInfo: '/api/1/expertmain/tag/queryTagInfo',
  getTagInfoList: '/api/1/expertmain/tag/getTagInfoList',
  getTagInfo: '/api/1/expertmain/tag/getTagInfo',
  addTagInfo: '/api/1/expertmain/tag/addTagInfo',
  updateTagInfo: '/api/1/expertmain/tag/updateTagInfo',
  deleteTagInfo: '/api/1/expertmain/tag/deleteTagInfo',
  saveOrUpdateExpertTagConcern: '/api/1/expertmain/expertTag/saveOrUpdateExpertTagConcern',
  deleteExpertTagConcern: '/api/1/expertmain/expertTag/deleteExpertTagConcern',
}

/**
 *  获取标签列表
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const QueryTagInfo = (data) => axios.get(api.queryTagInfo, { params: { ...data } })

/**
 *  获取标签列表
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const GetTagInfoList = (data) => axios.get(api.getTagInfoList, { params: { ...data } })

/**
 * 获取标签信息
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const GetTagInfo = (data) => axios.get(api.getTagInfo, { params: { ...data } })
/**
 * 添加标签信息
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const AddTagInfo = (data) => axios.post(api.addTagInfo, qs.stringify(data))
/**
 * 更新标签信息
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const UpdateTagInfo = (data) => axios.post(api.updateTagInfo, qs.stringify(data))
/**
 * 删除标签信息
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const DeleteTagInfo = (data) => axios.post(api.deleteTagInfo, qs.stringify(data))
/**
 * 保存或更新专家标签关注
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const SaveOrUpdateExpertTagConcern = (data) => axios.post(api.saveOrUpdateExpertTagConcern, qs.stringify(data, { allowDots: true }))

/**
 * 删除专家标签关注
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const DeleteExpertTagConcern = (data) => axios.post(api.deleteExpertTagConcern, data)
